export default "__VITE_ASSET__K5aaEQsi__"